var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isLoading ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [!_vm.readOnly ? _c('div', {
    staticClass: "col-12 text-right mb-3"
  }, [_c('OmniButton', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.isSaving,
      "isProcessing": _vm.isSaving,
      "variant": "success",
      "type": "submit",
      "icon": "save",
      "size": "lg"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")])], 1) : _vm._e(), _c('div', {
    staticClass: "col-12"
  }, [_vm.error ? _c('div', {
    staticClass: "alert alert-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "col-12 col-md-6 mt-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.label.title')) + " ")]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.number')) + " ")])]), _c('div', {
    staticClass: "col-sm-10"
  }, [!_vm.isNewLocation ? _c('span', {
    staticClass: "form-control-plaintext"
  }, [_vm._v(_vm._s(_vm.location.identifier))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.location.identifier,
      expression: "location.identifier",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "identifier",
      "required": "",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.location.identifier
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.location, "identifier", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.display-name')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.location.display_name,
      expression: "location.display_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "display_name",
      "required": "",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.location.display_name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.location, "display_name", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.location-type')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [!_vm.isNewLocation ? _c('span', {
    staticClass: "form-control-plaintext"
  }, [_vm._v(" " + _vm._s(_vm.$t(`${_vm.location.location_type.display_name}`)) + " ")]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.location.location_type_id,
      expression: "location.location_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "readonly": _vm.readOnly
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.location, "location_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.locationTypes, function (type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(_vm.$t(`${type.display_name}`)))]);
  }), 0)])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.active')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "form-control-plaintext"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.location.active,
      expression: "location.active"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.readOnly
    },
    domProps: {
      "checked": Array.isArray(_vm.location.active) ? _vm._i(_vm.location.active, null) > -1 : _vm.location.active
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.location.active,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.location, "active", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.location, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.location, "active", $$c);
        }
      }
    }
  })])])])])]), _c('div', {
    staticClass: "card mt-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.contact-info')))]), _vm._l(_vm.emailTypes, function (emailType) {
    return _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('i', [_vm._v(_vm._s(emailType.display_name))])]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.locationEmails[emailType.id],
        expression: "locationEmails[emailType.id]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "email",
        "readonly": _vm.readOnly
      },
      domProps: {
        "value": _vm.locationEmails[emailType.id]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.locationEmails, emailType.id, $event.target.value);
        }
      }
    })])]);
  }), _vm._l(_vm.phoneTypes, function (phoneType) {
    return _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('i', [_vm._v(_vm._s(phoneType.display_name))])]), _c('div', {
      staticClass: "@if($phoneType.identifier == 'sameday') col-sm-6 @else col-sm-10 @endif"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.locationPhoneNumbers[phoneType.id],
        expression: "locationPhoneNumbers[phoneType.id]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "readonly": _vm.readOnly
      },
      domProps: {
        "value": _vm.locationPhoneNumbers[phoneType.id]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.locationPhoneNumbers, phoneType.id, $event.target.value);
        }
      }
    })])]);
  })], 2)])]), _c('div', {
    staticClass: "col-12 col-md-6 mt-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-info')))]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-type')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_vm.addressTypes.length > 1 ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedAddressTypeId,
      expression: "selectedAddressTypeId"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readOnly
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedAddressTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.addressTypes, function (type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.display_name))]);
  }), 0) : _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.addressTypes[0].display_name
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-street')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].street,
      expression: "locationAddresses[selectedAddressTypeId].street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].street
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "street", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-houseno')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].house_no,
      expression: "locationAddresses[selectedAddressTypeId].house_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].house_no
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "house_no", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-houseno-extra')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].house_no_extra,
      expression: "locationAddresses[selectedAddressTypeId].house_no_extra"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].house_no_extra
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "house_no_extra", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-postal')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].zipcode,
      expression: "locationAddresses[selectedAddressTypeId].zipcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].zipcode
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "zipcode", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-city')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].city,
      expression: "locationAddresses[selectedAddressTypeId].city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].city
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "city", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-province')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].county,
      expression: "locationAddresses[selectedAddressTypeId].county"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].county
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "county", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-country')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].country,
      expression: "locationAddresses[selectedAddressTypeId].country"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].country
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "country", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-coords-lat')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].latitude,
      expression: "locationAddresses[selectedAddressTypeId].latitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].latitude
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "latitude", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.address-coords-lon')))])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddresses[_vm.selectedAddressTypeId].longitude,
      expression: "locationAddresses[selectedAddressTypeId].longitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.locationAddresses[_vm.selectedAddressTypeId].longitude
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.locationAddresses[_vm.selectedAddressTypeId], "longitude", $event.target.value);
      }
    }
  })])])])])]), !_vm.readOnly ? _c('div', {
    staticClass: "col-12 text-right mt-2"
  }, [_c('OmniButton', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.isSaving,
      "isProcessing": _vm.isSaving,
      "variant": "success",
      "type": "submit",
      "icon": "save",
      "size": "lg"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")])], 1) : _vm._e()])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }